import SearchingTextInput from './SearchingTextInput';

export default SearchingTextInput;
